import {Component} from '@angular/core';
import {Field} from '../../../../model/field.model';
import {Line} from '../../../../model/line.model';
import {Tree} from '../../../../model/tree.model';
import {StateService} from '../../../../state.service';
import {Location} from '@angular/common';
import {TruffleFound} from '../../../../model/truffelFound.model';
import {Router} from '@angular/router';

@Component({
    selector: 'app-truffle',
    templateUrl: './truffle.component.html',
    styleUrls: ['./truffle.component.css'],
    standalone: false
})
export class TruffleComponent {
  field: Field;
  line: Line;
  tree: Tree;

  constructor(private stateService: StateService, private location: Location, private router: Router) {
    this.tree = stateService.tree;
    this.line = stateService.line;
    this.field = stateService.field;
    if (!this.tree) {
      this.location.back();
    }
  }


  deleteTruffle(found: TruffleFound) {
    const index: number = this.field.lines[this.line.id - 1].trees[this.tree.id - 1].truffleFounds.indexOf(found);
    if (index !== -1) {
      this.field.lines[this.line.id - 1].trees[this.tree.id - 1].truffleFounds.splice(index, 1);
      this.stateService.deleteTruffle(this.field);
    }
  }

  editTruffle(truffleFound: TruffleFound) {
    this.stateService.field = this.field;
    this.stateService.line = this.line;
    this.stateService.tree = this.tree;
    this.stateService.truffleFound = truffleFound;
    this.router.navigate( ['editTruffle']);
  }
}
